// `src/components/adminOverrides/FiscalYearOverrideControls.js`
import {Box, FormGroup, FormControl, Checkbox, FormControlLabel, Typography, Tooltip} from "@mui/material";
import {LocalizationProvider, DesktopDatePicker} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default function FiscalYearOverrides({
                                                isPostFire,
                                                defaultDate,
                                                overrideActive,
                                                overrideDate,
                                                onEnabledChange,
                                                onDateChange,
                                                handleSave,
                                                loading

                                            }) {

    const handleCheckboxChange = (e) => {
        onEnabledChange(e.target.checked);
    };

    const handleDateChange = (value) => {
        onDateChange(value ? new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())).toISOString() : null);
    };

    return (<Box>
            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, margin: '10px'}}>
                <Typography sx={{width: '250px'}}><b>{isPostFire && isPostFire === true ? 'PostFire' : 'Fuels'} Fiscal
                    Year Override:</b></Typography>
                <FormGroup sx={{flexDirection: 'row', alignItems: 'center', gap: 2}}>
                    <FormControlLabel
                        control={<Checkbox
                            style={{padding: 0, margin: '0 5px 0 0'}}
                            checked={overrideActive}
                            name={`${isPostFire ?'postFire' : 'fuels'}OverrideActive`}
                            onChange={handleCheckboxChange}
                        />}
                        label="Enabled"
                    />
                    <FormControl variant="standard">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                format="MM/dd/yyyy"
                                value={overrideDate ? new Date(overrideDate) : null}
                                onChange={handleDateChange}
                                clearText="Clear"
                                closeOnSelect
                                slotProps={{actionBar: {actions: ['clear']}}}/>

                        </LocalizationProvider>
                    </FormControl>
                </FormGroup>
                <Typography sx={{ml: 2}}>
                    Default Fiscal Year Cutoff Date: <em>{defaultDate ? defaultDate.split('T')[0] : 'Not Set'}</em>
                </Typography>
                <Tooltip
                    title={loading ? 'Saving in progress...' : (overrideActive && !overrideDate ? 'Select a date before saving' : '')}
                    disableHoverListener={!(loading || (overrideActive && !overrideDate))}
                >
                    <span>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{ml: 2}}
                            onClick={handleSave}
                            aria-busy={loading}
                            disabled={loading || (overrideActive && !overrideDate)}
                            startIcon={loading ? <CircularProgress size={16}/> : null}
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </Button>
                    </span>
                </Tooltip>
            </Box>
            <hr/>
        </Box>
    );
}
